import $ from "jquery";
import fb from "@bd-core/firebase";

const GameLogic = {
    async init() {
        if ($(".app").length < 1) return false;
        if ($("#access-page").length > 0) return false;
        if ($("#create-session-page").length > 0) return false;
        // if ($("#page-welcome").length > 0) return false;

        // Initialize Firebase
        //-----------------------------------------------------------------------
        try {
            await fb.initializeGame();
        } catch (e) {
            console.error(e);
        }
        //-----------------------------------------------------------------------
    },

    registerGlobalListener() {},

    registerGlobalEvents() {},

    /**
     * This function is to listen an event when game progress was edited from backend
     */
    listenGameProgressChanged() {},
};

export default GameLogic;
